module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: ['livePoint', {
      'notShow': _vm.notShow
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "w90"
  }, [_c('img', {
    staticClass: "point20",
    attrs: {
      "src": require("./1.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientName),
      expression: "clientName"
    }],
    attrs: {
      "placeholder": "请输入真实姓名"
    },
    domProps: {
      "value": (_vm.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }, function($event) {
        _vm.mobile = _vm.mobile.replace(/[^\d]/g, '')
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputContent"
  }, [_c('div', {
    staticClass: "inputs codeinputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.verifyMsg != '验证码') ? _c('button', {
    staticClass: "getVerCode"
  }, [_vm._v(_vm._s(_vm.verifyMsg))]) : (_vm.cangetVerCode) ? _c('button', {
    staticClass: "getVerCode",
    on: {
      "click": _vm.getVerCode
    }
  }, [_vm._v(_vm._s(_vm.verifyMsg))]) : _c('button', {
    staticClass: "getVerCode grayCode"
  }, [_vm._v(_vm._s(_vm.verifyMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "inputContent"
  }, [_c('div', {
    staticClass: "inputs codeinputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgCode),
      expression: "imgCode"
    }],
    attrs: {
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.imgCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "getVerCode"
  }, [_c('img', {
    attrs: {
      "src": _vm.verCodeUrl
    },
    on: {
      "click": _vm.getVerCodeUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('div', {
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("一键申领")])]), _vm._v(" "), _c('div', {
    staticClass: "submittext"
  }, [_vm._v("点击一键申请，未注册的手机号将一键注册东航金融APP")])]), _vm._v(" "), _c('div', {
    staticClass: "dlContent"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "dlImg"
  }, [_c('img', {
    attrs: {
      "src": require("./Andriod.png")
    },
    on: {
      "click": _vm.Download
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./iOS.png")
    },
    on: {
      "click": _vm.Download
    }
  })])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('alert', {
    attrs: {
      "showModal": _vm.showAlert
    },
    on: {
      "update:showModal": function($event) {
        _vm.showAlert = $event
      },
      "update:show-modal": function($event) {
        _vm.showAlert = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.alertMessage))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titleimg"
  }, [_c('img', {
    attrs: {
      "src": require("./tittle.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dl"
  }, [_c('img', {
    attrs: {
      "src": require("./dl.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigcontent"
  }, [_c('div', {
    staticClass: "bigimg"
  }, [_c('img', {
    attrs: {
      "src": require("./dlb.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "staticimg"
  }, [_c('img', {
    attrs: {
      "src": require("./buttom.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4f2f486"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/livepoint/index.vue
// module id = 848
// module chunks = 2